// Services
import { NetworkService } from './core/services/network/network.service';
import { PwaService } from './core/services/pwa/pwa.service';
import { StorageService } from './core/services/storage/storage.service';
import { TranslationService } from './core/services/translation/translation.service';

// Utils
import { KeyboardUtils } from './core/utils/keyboard/keyboard.service';

// Types
import { StorageKey } from './shared/types/storage';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export const initializeApp = (
  storage: StorageService,
  translate: TranslationService,
  pwa: PwaService,
  network: NetworkService,
  keyboard: KeyboardUtils,
): (() => void) => {
  // eslint-disable-next-line no-console
  console.log('[AppInizialier]', '(initializeApp)');
  network.appStarted();

  return async () => {
    await pwa.checkIfRunningInIncognito();

    storage.getFromStorage<string>(StorageKey.Lang).subscribe({
      next: (lang: string | null | undefined) => {
        if (lang === null) {
          lang = 'en';
        }

        translate.setCurrentLanguage(lang ?? 'en');
      },
      error: () => {
        translate.setCurrentLanguage('en');
      },
    });

    storage.getFromStorage(StorageKey.CurrentEnvironment).subscribe({
      error: () => {
        storage.setOnStorage(StorageKey.CurrentEnvironment, 'web').subscribe();
      },
    });

    storage.getFromStorage(StorageKey.ZoomMode).subscribe({
      error: () => {
        storage.setOnStorage(StorageKey.ZoomMode, 'A').subscribe();
      },
    });

    const docStyle = document.documentElement.style;
    const ionSafeAreaTop = docStyle.getPropertyValue('--ion-safe-area-top');
    if (ionSafeAreaTop === '') {
      document.documentElement.style.setProperty('--safe-area-top', '16px');
    }
    const ionSafeAreaBottom = docStyle.getPropertyValue('--ion-safe-area-bottom');
    if (ionSafeAreaBottom === '') {
      document.documentElement.style.setProperty('--safe-area-bottom', '16px');
    }

    console.log('[AppInizialier]', '(initializeApp)', 'os: ' + pwa.os);

    if (pwa.os === 'Android') {
      console.log('[AppInizialier]', '(initializeApp)', 'listenKeyboardChanges');
      keyboard.listenKeyboardChanges();
    }
  };
};
